export const selector = 'dbAScrollContainer';

class ScrollContainerController {
    /* @ngInject */
    constructor($element) {
        this.$element = $element;
    }

    scrollToElement(element) {
        this.$element[0].scrollTop = this.getScrollPositionCenter(element);
    }

    getScrollPositionCenter(element) {
        return element.offsetTop + (element.clientHeight - this.$element[0].clientHeight) / 2;
    }
}

/* @ngInject */
export default function ScrollContainerDirective() {
    return {
        restrict: 'A',
        controller: ScrollContainerController
    };
}



// WEBPACK FOOTER //
// ./src/application/directive/scroll-container/scroll-container.directive.js